import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useContext } from "react";

import { AuthenticatorContext } from "@/shared/components/Authenticator";

export const Route = createFileRoute("/_unauthenticated")({
  component: Unauthenticated,
});

function Unauthenticated() {
  const authCtx = useContext(AuthenticatorContext);
  if (authCtx.user) {
    return <Navigate to="/balance" />;
  }
  return <Outlet />;
}
